<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png">
          <span>站点信息管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for='(item,index) in infoList' :key="index" @click="handleClick(item.uid)">
        <a>
          <img :src="item.img">
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name:"setManagement",  
  data(){
    return {
      setManagement: this.setManagement,//引入 lang 里面的字符串资源
      infoList:[],//数据源
    }
  },
  methods:{
    //点击每个
    handleClick(uid){
      console.log(uid);
      switch(uid){
        case 1:
          bus.$emit('homePage',{type:'jump',path:'/InformationPublish',title:this.setManagement.title_15});
          break;
        case 2:
          bus.$emit('homePage',{type:'jump',path:'/ActivePush',title:this.setManagement.title_16});
          break;
        case 3:
          bus.$emit('homePage',{type:'jump',path:'/InformationMassagePush',title:this.setManagement.title_17});
          break;
        case 4:
          bus.$emit('homePage',{type:'jump',path:'/BaseInfo',title:"基础信息"});
          break;
        case 5:
          bus.$emit('homePage',{type:'jump',path:'/Dictionary',title:this.setManagement.title_5});
          break; 
        
      }
    },

    /**
     * 获取菜单栏的数据列表
    */
    getPageData() {
      this.infoList = [
        {
          img:require("@/assets/beadhouse/ActivePush.png"),
          title:"基础信息",
          text:"居家中心基本信息详情",
          uid:4,
          url:"BaseInfo"
        },
        {
          img:require("@/assets/beadhouse/InformationPublish.png"),
          title:"活动室管理",
          text:"多功能活动室管理",
          uid:1,
          url:"MultiRoomList"
        },
        {
          img:require("@/assets/beadhouse/ActivePush.png"),
          title:"活动发布",
          text:"站点活动的发布",
          uid:2,
          url:"ActiveList"
        },
        {
          img:require("@/assets/beadhouse/InformationMassagePush.png"),
          title:'信息发布',
          text:'机构信息发布',
          uid:3,
          url:"InformationMassagePush"
        }
      ]
      
    }
  },
  created(){
    this.getPageData(); 
  },
  mounted(){
        
  },
}
</script>
<style lang="scss" scoped>
  .public_bg {
    min-width: 100%;
    height: 95%;
    padding:0px 0 20px 0;
    background: #FEFEFE;
    .nurse_top {
      border: 1px #F1EFF2 solid;
      background: #F9F7FA;
      position: relative;
        img {
          margin: 14px 12px;
        }
        h5 {
          display: inline-block;
          position: absolute;
          top: 12px;
          font-size: 18px;
        }
    }
    .row_link{
      width: 1259px;
      margin: 34px 35px;
      .item {
        width: 275px;
        height: 99px;
        border: #F0F0F2 1px solid;
        margin-bottom: 34px;
        margin-right: 34px;
        float: left;
        cursor: pointer;
        img {
          float: left;
          margin: 8px 23px 8px 33px;
          margin-right: 16px;
        }
        span {
          color: #666666;
        }
        h5 {
          margin-top: 21px;
          margin-bottom: 8px;
        }
        a:hover {
          color: #333; 
        }
      }
      .item:hover{
        border:1px solid red;
      }
    }
  }
</style>
